import { VehicleConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case VehicleConstant.SET_VEHICLE:
      return { ...state, detail: payload };
    case VehicleConstant.SET_VEHICLES:
      return { ...state, list: payload };
    default:
      return state;
  }
};
